import React, { useState, useEffect } from "react";
import styles from "./ERPTable.module.css";
import Pagination from "./Pagination";
import {
  getAllPurchasesErpData,
  purchaseListing,
} from "../../../Bookclosure/Services/ApiHandler";

const ERPTable = ({ PurchaseID }) => {
  const headers = [
    "Invoice No",
    "Company",
    "Supplier",
    "Posting Date",
    "Bill No",
    "Currency",
    "Net Total",
    "Taxes & Charges",
    "Grand Total",
    "Outstanding Amount",
    "Status",
  ];

  const [allData, setAllData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [currentData, setCurrentData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!PurchaseID) return;
      try {
        const res = await getAllPurchasesErpData(PurchaseID);
        const erpList =
          res.data?.ERPPurchaseList ||
          res.data?.data ||
          (Array.isArray(res.data) ? res.data : []);

        if (erpList && erpList.length > 0) {
          const records = erpList.flatMap((pkg) => {
            if (Array.isArray(pkg.data) && pkg.data.length > 0) {
              return pkg.data;
            }
            if (pkg.name || pkg.company || pkg.supplier) {
              return [pkg];
            }
            return [];
          });

          if (records.length > 0) {
            setAllData(records);
            return;
          }
        }

        const listingRes = await purchaseListing(PurchaseID, {
          page: 1,
          pageSize: 1000,
          filters: [],
        });
        if (listingRes.data?.purchaseListing?.length > 0) {
          setAllData(listingRes.data.purchaseListing);
        }
      } catch (err) {
        console.error("Failed to fetch ERP purchases table data:", err);
      }
    };
    fetchData();
  }, [PurchaseID]);

  const totalPages = Math.ceil(allData.length / rowsPerPage) || 1;

  useEffect(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    setCurrentData(allData.slice(startIndex, endIndex));
  }, [allData, currentPage, rowsPerPage]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td
                    colSpan={headers.length}
                    style={{ textAlign: "center", padding: "32px", color: "#777" }}
                  >
                    No ERP records found.
                  </td>
                </tr>
              ) : (
                currentData.map((row, index) => (
                  <tr key={index} className={styles.tableRow}>
                    <td className={styles.tableCell}>
                      {row.name || row.invoiceNo || row.invoice_no || row.invoiceNumber || "-"}
                    </td>
                    <td className={styles.tableCell}>
                      {row.company || row.companyName || "-"}
                    </td>
                    <td className={styles.tableCell}>
                      {row.supplier || row.supplierName || row.party_name || "-"}
                    </td>
                    <td className={styles.tableCell}>
                      {row.posting_date || row.postingDate || row.date || row.invoiceDate || "-"}
                    </td>
                    <td className={styles.tableCell}>
                      {row.bill_no || row.billNo || "-"}
                    </td>
                    <td className={styles.tableCell}>
                      {row.currency || row.docCurrency || row.foreignCurrency || "INR"}
                    </td>
                    <td className={styles.tableCell}>
                      {typeof (row.net_total ?? row.netTotal) === "number"
                        ? (row.net_total ?? row.netTotal).toLocaleString()
                        : (row.net_total ?? row.netTotal ?? "0")}
                    </td>
                    <td className={styles.tableCell}>
                      {typeof (row.total_taxes_and_charges ?? row.taxTotal ?? row.taxAmount) === "number"
                        ? (row.total_taxes_and_charges ?? row.taxTotal ?? row.taxAmount).toLocaleString()
                        : (row.total_taxes_and_charges ?? row.taxTotal ?? row.taxAmount ?? "0")}
                    </td>
                    <td className={styles.tableCell}>
                      {typeof (row.grand_total ?? row.grandTotal ?? row.invoiceAmount) === "number"
                        ? (row.grand_total ?? row.grandTotal ?? row.invoiceAmount).toLocaleString()
                        : (row.grand_total ?? row.grandTotal ?? row.invoiceAmount ?? "0")}
                    </td>
                    <td className={styles.tableCell}>
                      {typeof (row.outstanding_amount ?? row.outstandingAmount) === "number"
                        ? (row.outstanding_amount ?? row.outstandingAmount).toLocaleString()
                        : (row.outstanding_amount ?? row.outstandingAmount ?? "0")}
                    </td>
                    <td className={styles.tableCell}>
                      <span
                        style={{
                          padding: "3px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          display: "inline-block",
                          backgroundColor:
                            (row.status === "Paid" || !row.status) ? "#e6f9ed" : "#fff1f0",
                          color:
                            (row.status === "Paid" || !row.status) ? "#1e8e3e" : "#d93025",
                        }}
                      >
                        {row.status || "Paid"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default ERPTable;
